<th class="kpi-name bg-sortable" (click)="onSort()"
    [class.bg-ascending]="this.currentOrdering === this.column && isAscending"
    [class.not-filtered]="this.currentOrdering !== this.column"
    [class.bg-descending]="this.currentOrdering === this.column && !isAscending">
    <ng-content></ng-content>
    <div class="containerSort">
        <img class="ascendingFilter" src="assets/ascending-filter-icon.svg" alt="ascendingFilter" />
        <img class="descendingFilter" src="assets/descending-filter-icon.svg" alt="descendingFilter" />
    </div>
</th>